<template>
  <div>
    <h3>General description</h3>
    <p>
      The constellation performance analysis mission has been designed to help
      the analyst to evaluate the coverage performances of a constellation of
      satellites over specified areas. Relevant metrics are computed such as the
      revisit time. The underlying algorithm has been optimised in a way that
      allows to simulate large constellations of hundreds of spacecrafts in just
      a few seconds.
    </p>
    <h3>Hypotheses</h3>
    <p>The underlying assumptions for this module are the following:</p>
    <ul>
      <li>The Earth geometry is considered spherical</li>
      <li>Only circular orbits are considered</li>
      <li>
        The only perturbation taken into account is the oblateness of the Earth
        (<katex-element expression="J_2" /> harmonic of the potential)
      </li>
      <li>Earth meshes are rectangular</li>
      <li>The Sun position is given by JPL ephemerides</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipConstellationPerformanceAnalysisMission'
}
</script>
